import React, { useState, useEffect } from 'react';
import { ColorMode, getStoredColorMode, setColorMode, getActiveTheme } from '../../utils/colorMode';
import { useLayout } from './LayoutContext';

export const Header: React.FC = () => {
  const { toggleSidebar } = useLayout();
  const [currentMode, setCurrentMode] = useState<ColorMode>(getStoredColorMode());
  const [activeTheme, setActiveTheme] = useState<'light' | 'dark'>(getActiveTheme());

  useEffect(() => {
    // Update active theme when mode changes
    setActiveTheme(getActiveTheme());
  }, [currentMode]);

  const handleThemeChange = (mode: ColorMode) => {
    setColorMode(mode);
    setCurrentMode(mode);
  };

  const getThemeIcon = () => {
    if (activeTheme === 'dark') {
      return 'bi-moon-fill';
    }
    return 'bi-sun-fill';
  };

  const getThemeText = () => {
    if (currentMode === 'auto') return 'Auto';
    if (currentMode === 'dark') return 'Dark';
    return 'Light';
  };

  return (
    <nav className="navbar navbar-expand bg-body border-bottom sticky-top">
      <div className="container-fluid">
        {/* Start Navbar Links */}
        <ul className="navbar-nav align-items-center">
          <li className="nav-item">
            <button
              className="nav-link btn btn-link p-2"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <i className="bi bi-list fs-4"></i>
            </button>
          </li>
          <li className="nav-item d-none d-md-block">
            <span className="navbar-brand mb-0 h5 fw-semibold">
              BWS Market Maker Monitor
            </span>
          </li>
        </ul>

        {/* End Navbar Links */}
        <ul className="navbar-nav ms-auto">
          {/* Refresh Button */}
          <li className="nav-item d-none d-md-block">
            <button
              className="nav-link btn btn-link"
              onClick={() => window.location.reload()}
              title="Refresh data"
            >
              <i className="bi bi-arrow-clockwise"></i>
            </button>
          </li>

          {/* Theme Switcher Dropdown */}
          <li className="nav-item dropdown">
            <button
              className="btn btn-link nav-link py-2 px-0 px-lg-2 dropdown-toggle d-flex align-items-center"
              id="bd-theme"
              type="button"
              aria-expanded="false"
              data-bs-toggle="dropdown"
              data-bs-display="static"
              aria-label="Toggle theme"
            >
              <span className="theme-icon-active">
                <i className={`${getThemeIcon()} my-1`}></i>
              </span>
              <span className="d-lg-none ms-2">{getThemeText()}</span>
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="bd-theme"
              style={{ minWidth: '8rem' }}
            >
              <li>
                <button
                  type="button"
                  className={`dropdown-item d-flex align-items-center ${
                    currentMode === 'light' ? 'active' : ''
                  }`}
                  onClick={() => handleThemeChange('light')}
                  aria-pressed={currentMode === 'light'}
                >
                  <i className="bi bi-sun-fill me-2"></i>
                  Light
                  <i className={`bi bi-check-lg ms-auto ${currentMode === 'light' ? '' : 'd-none'}`}></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`dropdown-item d-flex align-items-center ${
                    currentMode === 'dark' ? 'active' : ''
                  }`}
                  onClick={() => handleThemeChange('dark')}
                  aria-pressed={currentMode === 'dark'}
                >
                  <i className="bi bi-moon-fill me-2"></i>
                  Dark
                  <i className={`bi bi-check-lg ms-auto ${currentMode === 'dark' ? '' : 'd-none'}`}></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`dropdown-item d-flex align-items-center ${
                    currentMode === 'auto' ? 'active' : ''
                  }`}
                  onClick={() => handleThemeChange('auto')}
                  aria-pressed={currentMode === 'auto'}
                >
                  <i className="bi bi-circle-half me-2"></i>
                  Auto
                  <i className={`bi bi-check-lg ms-auto ${currentMode === 'auto' ? '' : 'd-none'}`}></i>
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};
